<div [ngClass]="{open: navService.sidebarState.childnavOpen}" class="sidebar-left-secondary rtl-ps-none ps open"
  [perfectScrollbar]="{suppressScrollX: true}">
  <ul class="childNav" appDropdown>
    <li *ngFor="let item of nav" appDropdownLink class="nav-item">

      <a *ngIf="item.type === 'link'" [routerLinkActiveOptions]="{ exact: true }" [routerLink]="item.state" routerLinkActive="open" [routerLinkActiveOptions]="{ exact: true }">
        <i *ngIf="item.icon" [class]="'nav-icon material-icons'">{{item.icon}}</i>
        <span class="item-name lvl1">{{item.name}}</span>
      </a>

      <div *ngIf="item.type === 'dropDown'">
        <a appDropdownToggle [ngClass]="{open: item.active}" routerLinkActive="open">
          <i *ngIf="item.icon" class="nav-icon material-icons">{{item.icon}}</i>
          <span class="item-name">{{item.name}}</span>
          <i class="dd-arrow i-Arrow-Down"></i>
        </a>
        <ng-container *ngTemplateOutlet="menuTemplate;context:{parentItem: item}"></ng-container>
      </div>

    </li>
  </ul>
</div>

<ng-template #menuTemplate let-parentItem="parentItem">
  <ul class="childNav" appDropdown>
    <li *ngFor="let item of parentItem?.sub" appDropdownLink class="nav-item">

      <a *ngIf="item.type === 'link'" [routerLink]="item.state">
        <i *ngIf="item.icon" class="nav-icon material-icons">{{item.icon}}</i>
        <span class="item-name">{{item.name}}</span>
      </a>

      <div *ngIf="item.type === 'dropDown'">
        <a appDropdownToggle [ngClass]="{open: item.active}" routerLinkActive="open">
          <i *ngIf="item.icon" class="nav-icon material-icons">{{item.icon}}</i>
          <span class="item-name">{{item.name}}</span>
          <i class="dd-arrow i-Arrow-Down"></i>
        </a>
        <ng-container *ngTemplateOutlet="menuTemplate;context:{parentItem: item}"></ng-container>
      </div>
    </li>
  </ul>
</ng-template>
